export const dopis_olaksica_prvo_zaposlenje= {
    templateId: 69,
    category: 17,
    templateTitle: 'Zamolba HZMO-u za izdavanje potvrde o prvom zaposlenju (oslobođenje od plaćanja doprinosa za zdravstveno osiguranje)',
    templateDescription: `<p>Poslodavac može biti oslobođen od plaćanja doprinosa za zdravstveno osiguranje tijekom prve godine radnog odnosa radnika koji se prvi put zapošljava.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Prema Zakonu o doprinosima, poslodavac može biti oslobođen plaćanja doprinosa za zdravstveno osiguranje tijekom prve godine radnog odnosa, za radnika koji prethodno nema evidentiran staž u matičnoj evidenciji Hrvatskog zavoda za mirovinsko osiguranje. </p>
    <p>Da bi mogao iskoristiti pravo na navedeno oslobođenje, poslodavac mora osigurati dokaz − potvrdu HZMO-a da radnik nije prije zasnivanja radnog odnosa bio osiguranik obveznog mirovinskog osiguranja.  </p>
    <p>Pri tome, ugovor o radu ne treba biti sklopljen na neodređeno vrijeme i nije propisano dobno ograničenje za radnika, nego je jedini uvjet da radnik nije bio prethodno osiguranik po osnovi mirovinskog osiguranja.</p>
    <p>Zamolba za izdavanje takve potvrde nalazi se u predlošku ispod ovog teksta, a poslodavac potvrdu od HZMO-a može zatražiti <strong>nakon zasnivanja radnog odnosa</strong> te istu predočiti u slučaju nadzora. </p>
    <p><strong>Ovu olakšicu odnosi se na prvo zaposlenje radnika koji nema prethodno evidentiran radni staž te istu treba razlikovati od olakšice pri zapošljavanju radnika mlađih od trideset godina na neodređeno vrijeme, pri čemu se zadnje navedena olakšica može koristiti sljedećih 5 godina.</strong></p>
    <p><strong>Također, važno je naglasiti da se ove mjere mogu kumulirati te da poslodavac prvo može koristiti olakšica za prvo zaposlenje (do 1 godine), a potom i olakšicu u slučaju sklapanja prvog ugovora na neodređeno vrijeme radnika koji je mlađi od 30 godina.</strong></p>

    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o doprinosima.</p>
  `,
  sides: [
      {
        prefix: "HZMO",
        signature: "",
        inputs: [{
          type: "input",
          required: true,
          placeholder: "Npr. Reg. služba u Splitu",
        },
      ],
        suffix: "",
      }
    ],

    headline: "",
    title: '\r\n\r\nPREDMET: Zamolba za izdavanje potvrde o prvom zaposlenju',
    noArticleNumbers: true,
    noArticleTitle: true,
    suffix: ' ',

    articles: [
            
                {
                    title: '',
                    mandatory: true,
                    dummy: true,
                    exampleContent: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Poštovani,\r\n\r\nmolim Vas da izdate potvrdu da radniku  ____________________, iz ____________________, OIB:__________________, radni odnos započet dana ___________ godine kod _________________________, predstavlja prvo zaposlenje te da do navedenog datuma nije bio osiguranik obveznog mirovinskog osiguranja.  \r\n\r\nPotvrda se traži u svrhu  ispunjenja uvjeta za oslobođenje od plaćanja doprinosa sukladno čl. 20. st. 2. i 3. Zakona o doprinosima. \r\n\r\nS poštovanjem.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) HZMO \r\n2) Kadrovska služba',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/69_dopis_olaksica_prvo_zaposlenje.ts